import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { incidentRouteDecision, useIncidentDocs } from "./feature";

/** Incident pages stay unmounted until the flag is on, so they make no incident requests. */
export default function IncidentGate({ children }: { children: ReactElement }) {
  const decision = incidentRouteDecision(useIncidentDocs());
  if (decision === "redirect") return <Navigate to="/threats" replace />;
  if (decision === "wait") return null;
  return children;
}
